import { AccessLayout } from "./accessLayout";
import { LuCircleCheck } from "react-icons/lu";
import React, { useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
//Components
import { LoginInput } from "./loginInput";
//Styles
import "./style.css";
import "./responsive.css";
import { resetPassword } from "../../api/login";


export default function RecoverPassword() {
  const navigate = useNavigate();
  let { token } = useParams();
  const [passwordChanged, setPasswordChanged] = useState(false);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState("");
  const inFlight = useRef(false);

  const goToHome = () => {
    navigate("/");
  };

  const handlePassword = async () => {
    if (inFlight.current) return;
    const password = document.getElementById("passwordInput").value;
    if (!password) { setError("Introduce tu nueva contraseña."); return; }
    inFlight.current = true;
    setPending(true);
    setError("");
    try {
      const response = await resetPassword({ code: token, newPassword: password });
      if (response?.error === false) setPasswordChanged(true);
      else if (response?.message === "Code not valid") {
        setError("El enlace no es válido, ha caducado o ya se ha utilizado. Solicita un nuevo enlace desde el inicio de sesión.");
      } else {
        setError("No se ha podido actualizar la contraseña. Vuelve a intentarlo o solicita un nuevo enlace desde el inicio de sesión.");
      }
    } catch {
      setError("No se ha podido confirmar el cambio. Revisa la conexión; si no puedes acceder, solicita un nuevo enlace desde el inicio de sesión.");
    } finally {
      inFlight.current = false;
      setPending(false);
    }
  };

  return <AccessLayout
    eyebrow="RECUPERA TU ACCESO"
    title={passwordChanged ? "Contraseña actualizada" : "Crea tu nueva contraseña"}
    intro={passwordChanged ? "Tu acceso ya está listo. Vuelve a iniciar sesión con tu nueva contraseña." : "Elige una nueva contraseña para acceder a la administración de tu negocio."}
    onBack={goToHome} pending={pending}>
    {passwordChanged ? <div className="accessSuccess" role="status"><LuCircleCheck aria-hidden="true" /><strong>Se cambió con éxito tu contraseña</strong><p>Ya puedes volver al inicio de sesión.</p><button type="button" className="loginSubmit" onClick={goToHome}>Iniciar sesión</button></div> :
      <form noValidate aria-busy={pending} onSubmit={event => { event.preventDefault(); handlePassword(); }}>
        <label className="labelLogin" htmlFor="passwordInput">Nueva contraseña · Obligatoria</label>
        <LoginInput id="passwordInput" type="password" autoComplete="new-password" required disabled={pending} classname="w-100" />
        {error && <div role="alert" className="errorValue errorMessage">{error}</div>}
        <button type="submit" className="loginSubmit accessResetSubmit" disabled={pending}>{pending ? "Actualizando clave…" : "Actualizar clave"}</button>
      </form>}
  </AccessLayout>;
}
